<script>
import Layout from '@layouts/default'
import appConfig from '@src/app.config'

/**
 * Login component
 */
export default {
    page: {
        title: 'Авторизация',
        meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
    },
    components: { Layout },
    data() {
        return {
            phone         : '+7',
            password      : '',
            authError     : null,
            tryingToLogIn : false,
            isAuthError   : false,
        }
    },
    computed: {},
    methods: {
        async tryToLogIn() {

            this.tryingToLogIn = true;
            this.isAuthError   = false;
            this.authError     = null;

            let data_send = {
                'phone'    : this.phone,
                'password' : this.password,
            };

            let new_session = await this.$store.dispatch('sessions/FETCH_SESSIONS_CREATE', data_send);

            if(new_session === false){
                this.tryingToLogIn = false;
                this.authError = 'Ошибка авторизации';
                this.isAuthError = true;
            } else {
                window.localStorage.setItem('API_KEY_ZABOTA', new_session.token)
                this.$router.push({ name: 'Dashboard'});
            }

        },
    },
}
</script>

<template>
	<Layout>
		<!-- end row -->
		<div class="account-pages my-5">
			<div class="container">
				<div class="row justify-content-center" style="margin-left: 0px; margin-right: 0px">
					<div class="col-xl-4 form" style="max-width: 400px">
						<div class="card">
							<div class="card-body p-0">
								<div class="row">
									<div class="col p-5">

                                        <div class="mx-auto mb-5" style="margin-left: 30px !important; margin-bottom: 70px !important; margin-top: 10px !important">
                                            <a routerLink="/">
                                                <img src="@assets/images/logo.png" alt style="margin-left: -25px;"/>
                                            </a>
                                        </div>

										<div class="mx-auto mb-5">
											<a routerLink="/">
												<h3 class="d-inline align-middle ml-1 text-logo"
													>Личный кабинет</h3
												>
											</a>
										</div>

										<h6 class="h5 mb-0 mt-4">Добро пожаловать!</h6>
										<p class="text-muted mt-1 mb-4">
											Введите ваш номер телефона и пароль для доступа к личному кабинету.
										</p>

										<b-alert
											v-model="isAuthError"
											variant="danger"
											dismissible
											>{{ authError }}</b-alert
										>

										<b-form
											class="authentication-form"
											@submit.prevent="tryToLogIn"
										>
											<div class="form-group">
												<div class="input-group input-group-merge">
													<div class="input-group-prepend">
														<span class="input-group-text">
															<feather
																type="phone"
																class="align-middle icon-dual"
															></feather>
														</span>
													</div>
													<b-form-input
														id="phone"
														v-model="phone"
														type="text"
														required
														placeholder="Ваш номер телефона"
													></b-form-input>
												</div>
											</div>
											<div class="form-group mt-4">
												<label class="form-control-label">Пароль</label>
												<router-link
													to="forget-password"
													class="float-right text-muted text-unline-dashed ml-1"
													>Забыли пароль?</router-link
												>
												<div class="input-group input-group-merge">
													<div class="input-group-prepend">
														<span class="input-group-text">
															<feather
																type="lock"
																class="align-middle icon-dual"
															></feather>
														</span>
													</div>
													<b-form-input
														id="password"
														v-model="password"
														type="password"
														required
														placeholder="Введите пароль"
													></b-form-input>
												</div>
											</div>
											<div class="form-group mb-4">
												<div class="custom-control custom-checkbox">
													<input
														id="checkbox-signin"
														type="checkbox"
														class="custom-control-input"
														checked
													/>
													<label
														class="custom-control-label"
														for="checkbox-signin"
													>
														Запомнить меня
													</label>
												</div>
											</div>
											<b-form-group id="button-group" class="mt-4 mb-1">
												<b-button
													type="submit"
													variant="primary"
													class="btn-block"
													>Войти</b-button
												>
											</b-form-group>
										</b-form>
                                        <div class="col-12 text-center" style="margin-top: 20px">
                                            <p class="text-muted">
                                                Нет аккаунта?
                                                <router-link
                                                    tag="a"
                                                    to="/register"
                                                    class="text-primary font-weight-bold ml-1"
                                                >
                                                    <b>Зарегистрироваться</b>
                                                </router-link>
                                                <!-- <a
                                routerLink="/account/signup"
                                class="text-primary font-weight-bold ml-1"
                              >Sign Up</a>-->
                                            </p>
                                        </div>
									</div>
								</div>
							</div>
							<!-- end card-body -->
						</div>
						<!-- end card -->

					</div>
					<!-- end col -->
				</div>
				<!-- end row -->
			</div>
			<!-- end container -->
		</div>
	</Layout>
</template>

<style lang="scss">

    .account-pages {
        width: 100vw; margin: 0 !important; min-height: 100vh;
    }

    .form-control {
        height: calc( 1.5em + 1rem + 3px );
    }

    .container {
        width: 100vw;
        margin: 0;
        padding: 0;
        max-width: 100vw !important;
        min-height: 100vh;
    }

    .card {
        -webkit-box-shadow: 0px 5px 21px 6px rgba(34, 60, 80, 0.03);
        -moz-box-shadow: 0px 5px 21px 6px rgba(34, 60, 80, 0.03);
        box-shadow: 0px 5px 21px 6px rgba(34, 60, 80, 0.03);
    }

    .row.justify-content-center {
        min-height: 100vh;
        align-items: center !important;
    }

    .row.justify-content-center .card {
        max-width: 400px !important;
        width: 100%;
    }

    .auth-page-sidebar {
        background-position-x: right;
        .overlay {
            display: none !important
        }
    }
    .f-center {
        display: flex !important;
        justify-content: center !important;
        align-content: space-between !important;
        align-items: center !important;
        flex-direction: column !important;
    }
    .f-center img {width: calc(90% - 50px); max-width: 250px}
</style>

